/* Stylesheet */

.empty_chart_container {
  display: flex;
  height: 100%;
  justify-content: center;
  align-items: center;

  .wrapper_container {
    text-align: center;

    .icon {
      height: 96px;
      width: 96px;
      color: #dbe1ea;
    }

    .label {
      margin: 12px 0px 0px 0px;
      color: var(--ion-color-text-disabled);
    }
  }
}
